<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>用户角色管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户角色管理</span>
      </div>
      
      <!-- 搜索区域 -->
      <el-row :gutter="20" class="search-row">
        <el-col :span="8">
          <el-input placeholder="请输入用户名进行搜索" v-model="queryInfo.query" clearable @clear="getUserList">
            <el-button slot="append" icon="el-icon-search" @click="getUserList"></el-button>
          </el-input>
        </el-col>
      </el-row>

      <!-- 用户列表 -->
      <el-table :data="userList" border stripe style="width: 100%" v-loading="loading">
        <el-table-column type="index" label="#" width="50"></el-table-column>
        <el-table-column prop="username" label="用户名" width="180"></el-table-column>
        <el-table-column prop="name" label="姓名" width="180"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status === '0'">正常</el-tag>
            <el-tag type="danger" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="adddate" label="创建时间" width="180"></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showAssignRoleDialog(scope.row)" v-permission="'user:assignRole'">分配角色</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <!-- 分配角色对话框 -->
    <el-dialog title="分配角色" :visible.sync="assignRoleDialogVisible" width="50%" @close="assignRoleDialogClosed">
      <div>
        <p>当前用户：{{ currentUser.username }}</p>
        <p>当前角色：
          <el-tag v-for="role in userRoles" :key="role.id" closable @close="removeRole(role)" style="margin-right: 10px;">
            {{ role.roleName }}
          </el-tag>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddRoleDialog" v-if="allRoles.length > userRoles.length">添加角色</el-button>
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveUserRoles">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加角色对话框 -->
    <el-dialog title="添加角色" :visible.sync="addRoleDialogVisible" width="50%" append-to-body>
      <el-transfer
        v-model="selectedRoles"
        :data="transferData"
        :titles="['可选角色', '已选角色']"
        :button-texts="['移除', '添加']"
        :props="{
          key: 'id',
          label: 'roleName'
        }"
        @change="handleRoleChange">
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddRoles">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 查询参数
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10
      },
      // 用户列表
      userList: [],
      // 总记录数
      total: 0,
      // 加载状态
      loading: false,
      // 分配角色对话框可见性
      assignRoleDialogVisible: false,
      // 添加角色对话框可见性
      addRoleDialogVisible: false,
      // 当前选中的用户
      currentUser: {},
      // 用户当前拥有的角色
      userRoles: [],
      // 所有角色列表
      allRoles: [],
      // 穿梭框数据
      transferData: [],
      // 穿梭框选中的角色ID
      selectedRoles: []
    }
  },
  created() {
    this.getUserList()
    this.getAllRoles()
  },
  methods: {
    // 获取用户列表
    async getUserList() {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('users/', {
          params: this.queryInfo
        })
        if (res.status !== 0) {
          return this.$message.error('获取用户列表失败！')
        }
        this.userList = res.data
        this.total = res.count
      } catch (error) {
        console.error('获取用户列表失败:', error)
        this.$message.error('获取用户列表失败！')
      } finally {
        this.loading = false
      }
    },
    // 获取所有角色
    async getAllRoles() {
      try {
        const { data: res } = await this.$http.get('userrole/allroles')
        if (res.status !== 0) {
          return this.$message.error('获取角色列表失败！')
        }
        this.allRoles = res.roles
      } catch (error) {
        console.error('获取角色列表失败:', error)
        this.$message.error('获取角色列表失败！')
      }
    },
    // 显示分配角色对话框
    async showAssignRoleDialog(user) {
      this.currentUser = user
      this.assignRoleDialogVisible = true
      
      // 获取用户当前的角色
      try {
        const { data: res } = await this.$http.get(`userrole/${user.id}`)
        if (res.status !== 0) {
          return this.$message.error('获取用户角色失败！')
        }
        this.userRoles = res.roles || []
      } catch (error) {
        console.error('获取用户角色失败:', error)
        this.$message.error('获取用户角色失败！')
      }
    },
    // 关闭分配角色对话框
    assignRoleDialogClosed() {
      this.currentUser = {}
      this.userRoles = []
    },
    // 显示添加角色对话框
    showAddRoleDialog() {
      this.addRoleDialogVisible = true
      
      // 准备穿梭框数据
      this.transferData = this.allRoles.map(role => {
        return {
          id: role.id,
          roleName: role.roleName,
          roleCode: role.roleCode,
          description: role.description
        }
      })
      
      // 设置已选中的角色
      this.selectedRoles = this.userRoles.map(role => role.id)
    },
    // 处理角色选择变化
    handleRoleChange(value, direction, movedKeys) {
      console.log(value, direction, movedKeys)
    },
    // 确认添加角色
    confirmAddRoles() {
      // 根据选中的角色ID更新用户角色列表
      this.userRoles = this.allRoles.filter(role => this.selectedRoles.includes(role.id))
      this.addRoleDialogVisible = false
    },
    // 移除角色
    removeRole(role) {
      const index = this.userRoles.findIndex(item => item.id === role.id)
      if (index !== -1) {
        this.userRoles.splice(index, 1)
      }
    },
    // 保存用户角色
    async saveUserRoles() {
      try {
        const roleIds = this.userRoles.map(role => role.id)
        const { data: res } = await this.$http.post(`userrole/assign/${this.currentUser.id}`, roleIds)
        if (res.status !== 0) {
          return this.$message.error('分配角色失败！')
        }
        this.$message.success('分配角色成功！')
        this.assignRoleDialogVisible = false
      } catch (error) {
        console.error('分配角色失败:', error)
        this.$message.error('分配角色失败！')
      }
    },
    // 处理页码变化
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getUserList()
    },
    // 处理当前页变化
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getUserList()
    }
  }
}
</script>

<style scoped>
.search-row {
  margin-bottom: 20px;
}
</style>
